const locale = {
    startYear: 1900,
    endYear: 2099,
    formatYMD: 'yyyy-MM-dd',
    formatYM: 'yyyy-MM',
    formatY: 'yyyy',
    formatM: 'MM',
    formatD: 'dd',
    days: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
    shortDays: ['日', '月', '火', '水', '木', '金', '土'],
    shorterDays: ['日', '月', '火', '水', '木', '金', '土'],
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    shortMonths: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    shorterMonths: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    firstDayOfAWeek: 0,
    ok: '決定',
    cansel: 'キャンセル',
    clear: 'クリア',
    today: '今日',
    thisMonth: '今月',
    thisYear: '今年'
};

export default locale;
